import {
  GET_OVERVIEW_PROVINSI,
  GET_OVERVIEW_PROVINSI_SUCCESS,
  GET_OVERVIEW_PROVINSI_FAIL,
  GET_OVERVIEW_KABKOT,
  GET_OVERVIEW_KABKOT_SUCCESS,
  GET_OVERVIEW_KABKOT_FAIL,
  GET_OVERVIEW_KECAMATAN,
  GET_OVERVIEW_KECAMATAN_SUCCESS,
  GET_OVERVIEW_KECAMATAN_FAIL,
  GET_OVERVIEW_KELURAHAN,
  GET_OVERVIEW_KELURAHAN_SUCCESS,
  GET_OVERVIEW_KELURAHAN_FAIL,
  GET_OVERVIEW_RT_RW,
  GET_OVERVIEW_RT_RW_SUCCESS,
  GET_OVERVIEW_RT_RW_FAIL,
  GET_OVERVIEW_KOMISARIS_BASIS,
  GET_OVERVIEW_KOMISARIS_BASIS_SUCCESS,
  GET_OVERVIEW_KOMISARIS_BASIS_FAIL,
} from "./actionTypes";
import { API } from "../../API/api";

// get exco table
export const getOverviewProvinsi = (anggota) => (dispatch) => {
  dispatch({
    type: GET_OVERVIEW_PROVINSI,
  });

  const request = API.getOverviewProvinsi(anggota);
  return request.then(
    (response) => dispatch(getOverviewProvinsiSuccess(response.data)),
    (err) => dispatch(getOverviewProvinsiFail(err)),
  );
};

export const getOverviewProvinsiSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_PROVINSI_SUCCESS,
    payload: data,
  });
};

export const getOverviewProvinsiFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_PROVINSI_FAIL,
    payload: data,
  });
};

export const getOverviewKabkot = (anggota) => (dispatch) => {
  dispatch({
    type: GET_OVERVIEW_KABKOT,
  });

  const request = API.getOverviewKabkot(anggota);
  return request.then(
    (response) => dispatch(getOverviewKabkotSuccess(response.data)),
    (err) => dispatch(getOverviewKabkotFail(err)),
  );
};

export const getOverviewKabkotSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KABKOT_SUCCESS,
    payload: data,
  });
};

export const getOverviewKabkotFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KABKOT_FAIL,
    payload: data,
  });
};

export const getOverviewKecamatan = (anggota, id_provinsi) => (dispatch) => {
  dispatch({
    type: GET_OVERVIEW_KECAMATAN,
  });

  const request = API.getOverviewKecamatan(anggota, id_provinsi);
  return request.then(
    (response) => dispatch(getOverviewKecamatanSuccess(response.data)),
    (err) => dispatch(getOverviewKecamatanFail(err)),
  );
};

export const getOverviewKecamatanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KECAMATAN_SUCCESS,
    payload: data,
  });
};

export const getOverviewKecamatanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KECAMATAN_FAIL,
    payload: data,
  });
};

export const getOverviewKelurahan = (anggota) => (dispatch) => {
  dispatch({
    type: GET_OVERVIEW_KELURAHAN,
  });

  const request = API.getOverviewKelurahan(anggota);
  return request.then(
    (response) => dispatch(getOverviewKelurahanSuccess(response.data)),
    (err) => dispatch(getOverviewKelurahanFail(err)),
  );
};

export const getOverviewKelurahanSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KELURAHAN_SUCCESS,
    payload: data,
  });
};

export const getOverviewKelurahanFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KELURAHAN_FAIL,
    payload: data,
  });
};

export const getOverviewRtRw = (anggota) => (dispatch) => {
  dispatch({
    type: GET_OVERVIEW_RT_RW,
  });

  const request = API.getOverviewRtRw(anggota);
  return request.then(
    (response) => dispatch(getOverviewRtRwSuccess(response.data)),
    (err) => dispatch(getOverviewRtRwFail(err)),
  );
};

export const getOverviewRtRwSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_RT_RW_SUCCESS,
    payload: data,
  });
};

export const getOverviewRtRwFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_RT_RW_FAIL,
    payload: data,
  });
};

export const getOverviewKomisarisBasis = (anggota) => (dispatch) => {
  dispatch({
    type: GET_OVERVIEW_KOMISARIS_BASIS,
  });

  const request = API.getOverviewKomisarisBasis(anggota);
  return request.then(
    (response) => dispatch(getOverviewKomisarisBasisSuccess(response.data)),
    (err) => dispatch(getOverviewKomisarisBasisFail(err)),
  );
};

export const getOverviewKomisarisBasisSuccess = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KOMISARIS_BASIS_SUCCESS,
    payload: data,
  });
};

export const getOverviewKomisarisBasisFail = (data) => (dispatch) => {
  return dispatch({
    type: GET_OVERVIEW_KOMISARIS_BASIS_FAIL,
    payload: data,
  });
};
